import { html, nothing, render } from "lit-html";
import { pageType } from "@escapio/portal/state/pageType";
import { translate } from "@escapio/shared/l10n/translate";
import "@escapio/portal/components/ClickTracker";
import { getLoginPayload } from "@escapio/shared/state/login-cookie";
import { langId } from "@escapio/shared/l10n/lang-id";
import { onChangeCurrency, travelData } from "@escapio/portal/state/travelData";

const ALLOWED_LANG_IDS = ["de"];
const ALLOWED_CURRENCIES = ["EUR"];

customElements.define(
	"esc-login-link",
	class extends HTMLElement {
		connectedCallback() {
			onChangeCurrency(() => this.render());
			this.render();
		}

		render() {
			if (
				!ALLOWED_LANG_IDS.includes(langId) ||
				!ALLOWED_CURRENCIES.includes(travelData.currency)
			) {
				this.style.display = "none";
				return;
			} else {
				this.style.display = "";
			}

			const isPortalCustomer = getLoginPayload()?.isPortalCustomer;
			const url = isPortalCustomer
				? this.getAttribute("url-welcome")
				: this.getAttribute("url-login");
			const evtLabel = isPortalCustomer ? "Mein Konto" : "Login";

			const template = html`<esc-click-tracker
				class="header-menu__item"
				category="Header"
				action="Link geklickt"
				label="${evtLabel} - ${pageType}"
				use-event-queue
			>
				<a href=${url}
					><span
						><span class="fa fa-user-circle-o"></span>${isPortalCustomer
							? html`<span
									class="header-menu__item__icon-addon header-menu__item__icon-addon--login-indicator"
								></span>`
							: nothing}</span
					><span class="menu-item__label hidden-mobile"
						>${translate("customer_my_account")}</span
					></a
				>
			</esc-click-tracker>`;

			render(template, this, { host: this });
		}
	},
);
